// Generated by CoffeeScript 1.12.6
(function() {
  var toaster;

  toaster = null;

  module.exports = function(theme) {
    var ceri, toast;
    if (!toaster) {
      toaster = require("./toaster-component");
      toaster.mixins.push(theme.toaster);
      ceri = require("ceri/lib/wrapper");
      toaster = ceri(toaster);
      if (!window.customElements.get("ceri-toast")) {
        toast = require("./toast-component");
        toast.mixins.push(theme.toast);
        window.customElements.define("ceri-toast", ceri(toast));
      }
    }
    return toaster;
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri-toaster/toaster.js
// module id = 65
// module chunks = 1